// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".breadcrumb ol[data-v-3c0fd6ee]{display:flex;flex-wrap:wrap;list-style-type:none;margin:0;padding:0}.breadcrumb li[data-v-3c0fd6ee]{margin-right:8px}.breadcrumb li a[data-v-3c0fd6ee],.breadcrumb li span[data-v-3c0fd6ee]{color:#4e68c6}.breadcrumb li[data-v-3c0fd6ee]:after{content:\" » \";margin-left:8px}.breadcrumb li[data-v-3c0fd6ee]:last-child:after{content:\"\"}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
